import React, { useMemo, useState } from "react";
import { FontAwesomeIcon }
from "@fortawesome/react-fontawesome";
import ScrollableList from "../../../components/ScrollableList";

import {
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
	faSpinner
}
from "@fortawesome/free-solid-svg-icons";

export default function InsightsDrawer({
    display,
    title,

    insights = [],
    observations = [],
    potentialAssets = [],

    clickFunction,
    observationClickFunction,
    potentialAssetClickFunction,

    closeFunction,

    loading = false,
    observationsLoading = false,
    potentialAssetsLoading = false
})
{
	
	
	
	const [selectedType, setSelectedType] =
	    useState("INSIGHTS");
    const [search, setSearch] = useState("");
	
	const [expandedInsightIds, setExpandedInsightIds] =
	    useState([]);
		
		
		const activeList =
			    selectedType === "OBSERVATIONS"
			        ?
			        observations
			        :
			        selectedType === "ASSETS"
			            ?
			            potentialAssets
			            :
			            insights;


			const activeLoading =
			    selectedType === "OBSERVATIONS"
			        ?
			        observationsLoading
			        :
			        selectedType === "ASSETS"
			            ?
			            potentialAssetsLoading
			            :
			            loading;


			const activeTypeLabel =
			    selectedType === "OBSERVATIONS"
			        ?
			        "Observations"
			        :
			        selectedType === "ASSETS"
			            ?
			            "Potential Assets"
			            :
			            "Insights";


    //--------------------------------------------------------
    // Filter
    //--------------------------------------------------------

	const filteredItems =
	    useMemo(
	        () =>
	        {
	            const value =
	                search
	                    .trim()
	                    .toLowerCase();

	            if(value === "")
	            {
	                return activeList;
	            }

	            return activeList.filter(
	                (item) =>
	                {
	                    if(selectedType === "OBSERVATIONS")
	                    {
	                        return (
	                            (item.observationType || "")
	                                .toLowerCase()
	                                .includes(value)
	                            ||
	                            (item.description || "")
	                                .toLowerCase()
	                                .includes(value)
	                            ||
	                            (item.condition || "")
	                                .toLowerCase()
	                                .includes(value)
	                            ||
	                            (item.source || "")
	                                .toLowerCase()
	                                .includes(value)
	                        );
	                    }

	                    if(selectedType === "ASSETS")
	                    {
	                        return (
	                            (item.name || "")
	                                .toLowerCase()
	                                .includes(value)
	                            ||
	                            (item.description || "")
	                                .toLowerCase()
	                                .includes(value)
	                            ||
	                            (item.status || "")
	                                .toLowerCase()
	                                .includes(value)
	                        );
	                    }

	                    return (
	                        (item.title || "")
	                            .toLowerCase()
	                            .includes(value)
	                        ||
	                        (item.description || "")
	                            .toLowerCase()
	                            .includes(value)
	                        ||
	                        (item.subcategory || "")
	                            .toLowerCase()
	                            .includes(value)
	                    );
	                }
	            );
	        },
	        [
	            activeList,
	            search,
	            selectedType
	        ]
	    );

		function toggleInsightDescription(
		    event,
		    insightId)
		{
		    /*
		     * Stop the card's clickFunction from opening
		     * the individual insight.
		     */

		    event.stopPropagation();

		    setExpandedInsightIds(
		        (currentIds) =>
		        {
		            if(currentIds.includes(insightId))
		            {
		                return currentIds.filter(
		                    (id) =>
		                    {
		                        return id !== insightId;
		                    }
		                );
		            }

		            return [
		                ...currentIds,
		                insightId
		            ];
		        }
		    );
		}
    //--------------------------------------------------------
    // Compliance colour
    //--------------------------------------------------------

    function getComplianceStyle(status)
    {
        const value =
            (status || "")
                .toUpperCase();

        if(
            value.includes("NON-COMPLIANT")
            ||
            value.includes("NON COMPLIANT")
        )
        {
            return {
                background: "rgba(239,68,68,0.18)",
                color: "#f87171",
                border: "1px solid rgba(239,68,68,0.35)"
            };
        }


        if(
            value.includes("POTENTIAL")
            ||
            value.includes("CONCERN")
        )
        {
            return {
                background: "rgba(249,115,22,0.18)",
                color: "#fb923c",
                border: "1px solid rgba(249,115,22,0.35)"
            };
        }


        if(value.includes("COMPLIANT"))
        {
            return {
                background: "rgba(34,197,94,0.18)",
                color: "#4ade80",
                border: "1px solid rgba(34,197,94,0.35)"
            };
        }


        return {
            background: "rgba(148,163,184,0.16)",
            color: "#cbd5e1",
            border: "1px solid rgba(148,163,184,0.25)"
        };
    }
	
	
	const typeBarStyle =
	{
	    display: "flex",
	    alignItems: "stretch",

	    width: "calc(100% - 40px)",

	    margin: "0 0 14px 0",

	    borderRadius: "18px",

	    boxShadow:
	        "0 7px 18px rgba(0,0,0,0.20)",
		marginLeft:'20px',
		marginRight:'20px'
	};


	const typeButtonStyle =
	{
	    flex: 1,

	    display: "flex",
	    alignItems: "center",
	    justifyContent: "center",
	    gap: "7px",

	    height: "38px",
	    padding: "0 12px",

	    color: "#a9b4c3",

	    background:
	        "linear-gradient(180deg, #30353d 0%, #24282f 100%)",

	    border: "1px solid rgba(255,255,255,0.10)",

	    fontSize: "11px",
	    fontWeight: "750",

	    cursor: "pointer",
		
	};


	const leftTypeButtonStyle =
	{
	    borderTopLeftRadius: "19px",
	    borderBottomLeftRadius: "19px",

	    borderTopRightRadius: 0,
	    borderBottomRightRadius: 0
	};


	const middleTypeButtonStyle =
	{
	    marginLeft: "-1px",

	    borderRadius: 0
	};


	const rightTypeButtonStyle =
	{
	    marginLeft: "-1px",

	    borderTopLeftRadius: 0,
	    borderBottomLeftRadius: 0,

	    borderTopRightRadius: "19px",
	    borderBottomRightRadius: "19px"
	};


	const activeTypeButtonStyle =
	{
	    position: "relative",
	    zIndex: 2,

	    color: "#ffffff",

	    background:
	        "linear-gradient(135deg, #4f8dff 0%, #2465ec 100%)",

	    border: "1px solid #4f8dff",

	    boxShadow:
	        "0 5px 15px rgba(37,99,235,0.32)"
	};


	const typeCountStyle =
	{
	    minWidth: "20px",
	    height: "20px",

	    display: "inline-flex",
	    alignItems: "center",
	    justifyContent: "center",

	    padding: "0 6px",

	    color: "#ffffff",

	    background: "rgba(255,255,255,0.17)",

	    borderRadius: "10px",

	    fontSize: "9px",
	    fontWeight: "800"
	};
	
	
	const loadingOverlayStyle =
	{
	    position: "absolute",
	    zIndex: 20,

	    inset: "205px 0 0 0",

	    display: "flex",
	    alignItems: "center",
	    justifyContent: "center",

	    background:
	        "rgba(13, 16, 21, 0.76)",

	    backdropFilter:
	        "blur(5px)"
	};


	const loadingPanelStyle =
	{
	    display: "flex",
	    flexDirection: "column",
	    alignItems: "center",

	    padding: "25px 30px",

	    color: "#ffffff",

	    background:
	        "linear-gradient(145deg, rgba(47,53,62,0.97) 0%, rgba(20,23,28,0.97) 100%)",

	    border:
	        "1px solid rgba(255,255,255,0.13)",

	    borderRadius: "14px",

	    boxShadow:
	        "0 18px 42px rgba(0,0,0,0.38)"
	};


	const loadingWheelStyle =
	{
	    width: "46px",
	    height: "46px",

	    display: "flex",
	    alignItems: "center",
	    justifyContent: "center",

	    marginBottom: "15px",

	    color: "#ffffff",

	    background:
	        "linear-gradient(135deg, #4f8dff 0%, #2465ec 100%)",

	    borderRadius: "50%",

	    boxShadow:
	        "0 8px 22px rgba(37,99,235,0.38)",

	    fontSize: "20px"
	};


	const loadingTitleStyle =
	{
	    marginBottom: "6px",

	    color: "#ffffff",

	    fontSize: "14px",
	    fontWeight: "750"
	};


	const loadingTextStyle =
	{
	    color: "#9eabba",

	    fontSize: "11px"
	};
	
	const descriptionStyle =
	{
	    color: "#cbd3df",

	    fontSize: "12px",
	    lineHeight: "1.55",

	    transition:
	        "max-height 0.25s ease"
	};


	const collapsedDescriptionStyle =
	{
	    display: "-webkit-box",

	    overflow: "hidden",

	    WebkitBoxOrient: "vertical",
	    WebkitLineClamp: 2
	};


	const expandedDescriptionStyle =
	{
	    display: "block",

	    overflow: "visible"
	};


	const descriptionToggleStyle =
	{
	    display: "inline-flex",
	    alignItems: "center",
	    gap: "5px",

	    marginTop: "6px",
	    padding: 0,

	    color: "#62a3ff",
	    background: "transparent",
	    border: "none",

	    fontSize: "10px",
	    fontWeight: "700",

	    cursor: "pointer"
	};


	const descriptionToggleIconStyle =
	{
	    fontSize: "9px"
	};
	
	
	function renderInsights()
	{
	    return filteredItems.map(
	        (insight) =>
	        {
	            const descriptionExpanded =
	                expandedInsightIds.includes(
	                    insight.id
	                );

	            const complianceStyle =
	                getComplianceStyle(
	                    insight.complianceStatus
	                );

					return (
							
                        <div
                            key={insight.id}

                           

                            style={{
                                marginBottom: "10px",

                                padding: "15px",

                                borderRadius: "12px",

                                background:
                                    "rgba(255,255,255,0.055)",

                                border:
                                    "1px solid rgba(255,255,255,0.08)",

                                transition:
                                    "all 0.2s ease"
                            }}

                          
                        >

                            {/* TITLE */}

                            <div
                                style={{
                                    color: "#ffffff",

                                    fontSize: "13px",
                                    fontWeight: 600,

                                    lineHeight: "1.4"
                                }}
                            >
                                {insight.title}
                            </div>


                            {/* SUBCATEGORY */}

                            {
                                insight.subcategory &&

                                <div
                                    style={{
                                        marginTop: "4px",

                                        color: "#94a3b8",

                                        fontSize: "10px",

                                        textTransform:
                                            "uppercase",

                                        letterSpacing:
                                            "0.6px"
                                    }}
                                >
                                    {insight.subcategory}
                                </div>
                            }


                            {/* DESCRIPTION */}

							<div
							    style={{
							        ...descriptionStyle,

							        ...(descriptionExpanded
							            ?
							            expandedDescriptionStyle
							            :
							            collapsedDescriptionStyle)
							    }}
							>
							    {insight.description}
							</div>

							{
							    insight.description
							    &&
							    insight.description.length > 110
							    &&
							    <button
							        type="button"
							        style={descriptionToggleStyle}
							        onClick={(event) =>
							        {
							            toggleInsightDescription(
							                event,
							                insight.id
							            );
							        }}
							    >
							        {
							            descriptionExpanded
							                ?
							                "Show less"
							                :
							                "Read more"
							        }

							        <FontAwesomeIcon
							            icon={
							                descriptionExpanded
							                    ?
							                    faChevronUp
							                    :
							                    faChevronDown
							            }
							            style={descriptionToggleIconStyle}
							        />
							    </button>
							}


                            {/* STATS */}

                            <div
                                style={{
                                    display: "grid",

                                    gridTemplateColumns:
                                        "1fr 1fr 1fr",

                                    marginTop: "13px",

                                    paddingTop: "11px",

                                    borderTop:
                                        "1px solid rgba(255,255,255,0.08)"
                                }}
                            >

                                <Stat
                                    label="Risk"
                                    value={
                                        insight.riskScore
                                        ??
                                        "—"
                                    }
                                />

                                <Stat
                                    label="Urgency"
                                    value={
                                        insight.urgency
                                        ||
                                        "—"
                                    }
                                />

                                <Stat
                                    label="Confidence"
                                    value={
                                        insight.confidence != null
                                            ?
                                            insight.confidence + "%"
                                            :
                                            "—"
                                    }
                                />

                            </div>


                            {/* COMPLIANCE */}

                            <div
                                style={{
                                    marginTop: "12px",

                                    display: "flex",

                                    justifyContent:
                                        "space-between",

                                    alignItems: "center"
                                }}
                            >

                                <div
                                    style={{
                                        ...complianceStyle,

                                        padding:
                                            "4px 8px",

                                        borderRadius: "6px",

                                        fontSize: "9px",
                                        fontWeight: 700,

                                        letterSpacing:
                                            "0.5px",

                                        textTransform:
                                            "uppercase"
                                    }}
                                >
                                    {
                                        insight.complianceStatus
                                        ||
                                        "Not Assessed"
                                    }
                                </div>

								<div style={{cursor:'pointer'}} onClick={() =>
		                                    {
		                                        if(clickFunction)
		                                        {
		                                            clickFunction(
		                                                insight
		                                            );
		                                        }
		                                    }}
								>
                                    <FontAwesomeIcon
                                        icon={faChevronRight}

                                        style={{
                                            color: "#64748b",

                                            fontSize: "11px"
                                        }}
                                    />
								</div>
                            </div>

                        </div>

                    );
	        }
	    );
	}
	
	
	function renderObservations()
	{
	    return filteredItems.map(
	        (observation) =>
	        {
	            const descriptionExpanded =
	                expandedInsightIds.includes(
	                    "OBS-" + observation.id
	                );

	            return (

	                <div
	                    key={observation.id}

	                    style={{
	                        marginBottom: "10px",

	                        padding: "15px",

	                        borderRadius: "12px",

	                        background:
	                            "rgba(255,255,255,0.055)",

	                        border:
	                            "1px solid rgba(255,255,255,0.08)"
	                    }}
	                >

	                    {/* TYPE */}

	                    <div
	                        style={{
	                            color: "#ffffff",

	                            fontSize: "13px",
	                            fontWeight: 600,

	                            lineHeight: "1.4"
	                        }}
	                    >
	                        {
	                            observation.observationType
	                            ||
	                            "Observation"
	                        }
	                    </div>


	                    {/* CONDITION */}

	                    {
	                        observation.condition
	                        &&
	                        <div
	                            style={{
	                                marginTop: "4px",

	                                color: "#94a3b8",

	                                fontSize: "10px",

	                                textTransform: "uppercase",

	                                letterSpacing: "0.6px"
	                            }}
	                        >
	                            {observation.condition}
	                        </div>
	                    }


	                    {/* DESCRIPTION */}

	                    <div
	                        style={{
	                            ...descriptionStyle,

	                            marginTop: "9px",

	                            ...(descriptionExpanded
	                                ?
	                                expandedDescriptionStyle
	                                :
	                                collapsedDescriptionStyle)
	                        }}
	                    >
	                        {observation.description}
	                    </div>


	                    {
	                        observation.description
	                        &&
	                        observation.description.length > 110
	                        &&
	                        <button
	                            type="button"

	                            style={descriptionToggleStyle}

	                            onClick={(event) =>
	                            {
	                                toggleInsightDescription(
	                                    event,
	                                    "OBS-" + observation.id
	                                );
	                            }}
	                        >
	                            {
	                                descriptionExpanded
	                                    ?
	                                    "Show less"
	                                    :
	                                    "Read more"
	                            }

	                            <FontAwesomeIcon
	                                icon={
	                                    descriptionExpanded
	                                        ?
	                                        faChevronUp
	                                        :
	                                        faChevronDown
	                                }

	                                style={
	                                    descriptionToggleIconStyle
	                                }
	                            />

	                        </button>
	                    }


	                    {/* STATS */}

	                    <div
	                        style={{
	                            display: "grid",

	                            gridTemplateColumns:
	                                "1fr 1fr 1fr",

	                            marginTop: "13px",

	                            paddingTop: "11px",

	                            borderTop:
	                                "1px solid rgba(255,255,255,0.08)"
	                        }}
	                    >

	                        <Stat
	                            label="Condition"
	                            value={
	                                observation.condition
	                                ||
	                                "—"
	                            }
	                        />

	                        <Stat
	                            label="Source"
	                            value={
	                                observation.source
	                                ||
	                                "—"
	                            }
	                        />

	                        <Stat
	                            label="Confidence"
	                            value={
	                                observation.confidence != null
	                                    ?
	                                    observation.confidence + "%"
	                                    :
	                                    "—"
	                            }
	                        />

	                    </div>


	                    {
	                        observationClickFunction
	                        &&
	                        <div
	                            style={{
	                                marginTop: "12px",

	                                display: "flex",

	                                justifyContent: "flex-end"
	                            }}
	                        >
	                            <div
	                                style={{
	                                    cursor: "pointer"
	                                }}

	                                onClick={() =>
	                                {
	                                    observationClickFunction(
	                                        observation
	                                    );
	                                }}
	                            >
	                                <FontAwesomeIcon
	                                    icon={faChevronRight}

	                                    style={{
	                                        color: "#64748b",
	                                        fontSize: "11px"
	                                    }}
	                                />
	                            </div>
	                        </div>
	                    }

	                </div>

	            );
	        }
	    );
	}
	
	
	function renderPotentialAssets()
	{
	    return filteredItems.map(
	        (asset) =>
	        {
	            const descriptionExpanded =
	                expandedInsightIds.includes(
	                    "ASSET-" + asset.id
	                );

	            return (

	                <div
	                    key={asset.id}

	                    style={{
	                        marginBottom: "10px",

	                        padding: "15px",

	                        borderRadius: "12px",

	                        background:
	                            "rgba(255,255,255,0.055)",

	                        border:
	                            "1px solid rgba(255,255,255,0.08)"
	                    }}
	                >

	                    {/* NAME */}

	                    <div
	                        style={{
	                            color: "#ffffff",

	                            fontSize: "13px",
	                            fontWeight: 600,

	                            lineHeight: "1.4"
	                        }}
	                    >
	                        {
	                            asset.name
	                            ||
	                            "Detected Asset"
	                        }
	                    </div>


	                    {/* STATUS */}

	                    {
	                        asset.status
	                        &&
	                        <div
	                            style={{
	                                marginTop: "4px",

	                                color: "#62a3ff",

	                                fontSize: "10px",

	                                textTransform: "uppercase",

	                                letterSpacing: "0.6px"
	                            }}
	                        >
	                            {asset.status}
	                        </div>
	                    }


	                    {/* DESCRIPTION */}

	                    <div
	                        style={{
	                            ...descriptionStyle,

	                            marginTop: "9px",

	                            ...(descriptionExpanded
	                                ?
	                                expandedDescriptionStyle
	                                :
	                                collapsedDescriptionStyle)
	                        }}
	                    >
	                        {asset.description}
	                    </div>


	                    {
	                        asset.description
	                        &&
	                        asset.description.length > 110
	                        &&
	                        <button
	                            type="button"

	                            style={descriptionToggleStyle}

	                            onClick={(event) =>
	                            {
	                                toggleInsightDescription(
	                                    event,
	                                    "ASSET-" + asset.id
	                                );
	                            }}
	                        >
	                            {
	                                descriptionExpanded
	                                    ?
	                                    "Show less"
	                                    :
	                                    "Read more"
	                            }

	                            <FontAwesomeIcon
	                                icon={
	                                    descriptionExpanded
	                                        ?
	                                        faChevronUp
	                                        :
	                                        faChevronDown
	                                }

	                                style={
	                                    descriptionToggleIconStyle
	                                }
	                            />

	                        </button>
	                    }


	                    {/* STATS */}

	                    <div
	                        style={{
	                            display: "grid",

	                            gridTemplateColumns:
	                                "1fr 1fr 1fr",

	                            marginTop: "13px",

	                            paddingTop: "11px",

	                            borderTop:
	                                "1px solid rgba(255,255,255,0.08)"
	                        }}
	                    >

	                        <Stat
	                            label="Confidence"
	                            value={
	                                asset.confidence != null
	                                    ?
	                                    asset.confidence + "%"
	                                    :
	                                    "—"
	                            }
	                        />

	                        <Stat
	                            label="Status"
	                            value={
	                                asset.status
	                                ||
	                                "—"
	                            }
	                        />

	                        <Stat
	                            label="Matched"
	                            value={
	                                asset.matchedAssetId != null
	                                    ?
	                                    "Yes"
	                                    :
	                                    "No"
	                            }
	                        />

	                    </div>


	                    {
	                        potentialAssetClickFunction
	                        &&
	                        <div
	                            style={{
	                                marginTop: "12px",

	                                display: "flex",

	                                justifyContent: "flex-end"
	                            }}
	                        >
	                            <div
	                                style={{
	                                    cursor: "pointer"
	                                }}

	                                onClick={() =>
	                                {
	                                    potentialAssetClickFunction(
	                                        asset
	                                    );
	                                }}
	                            >
	                                <FontAwesomeIcon
	                                    icon={faChevronRight}

	                                    style={{
	                                        color: "#64748b",
	                                        fontSize: "11px"
	                                    }}
	                                />
	                            </div>
	                        </div>
	                    }

	                </div>

	            );
	        }
	    );
	}


    //--------------------------------------------------------
    // Render
    //--------------------------------------------------------

	return (

	    <>

	        {/* COLLAPSE / EXPAND TAB */}

	        <button
	            onClick={() =>
	                closeFunction()
	            }

	            style={{
	                position: "fixed",

	                top: "50%",
	                right:
	                    display
	                        ? "470px"
	                        : "-60px",

	                transform: "translateY(-50%)",

	                width: "42px",
	                height: "74px",

	                zIndex: 1001,

	                border: "none",

	                borderRadius: "12px 0 0 12px",

	                background:
	                    "linear-gradient(145deg, #24272d 0%, #111318 60%, #090a0d 100%)",

	                boxShadow:
	                    "-6px 0 18px rgba(0,0,0,0.20)",

	                color: "#ffffff",

	                fontSize: "15px",

	                cursor: "pointer",

	                transition:
	                    "right 0.65s cubic-bezier(0.22, 1, 0.36, 1)"
	            }}
	        >

	            <FontAwesomeIcon
	                icon={
	                    faChevronRight
	                }
	            />

	        </button>


	        {/* DRAWER */}

	        <div
	            style={{
	                position: "fixed",

	                top: 0,
	                right: 0,
	                bottom: 0,

	                width: "470px",
	                height: "100vh",

	                zIndex: 1000,

	                background:
	                    "linear-gradient(145deg, #24272d 0%, #111318 55%, #090a0d 100%)",

	                border: "none",

	                borderRadius: 0,

	                boxShadow:
	                    display
	                        ? "-12px 0 35px rgba(0,0,0,0.25)"
	                        : "none",

	                overflow: "hidden",

	                transform:
	                    display
	                        ? "translateX(0)"
	                        : "translateX(100%)",

	                transition:
	                    "transform 0.65s cubic-bezier(0.22, 1, 0.36, 1)",

	                display: "flex",
	                flexDirection: "column"
	            }}
	        >

	            {/* HEADER */}

	            <div
	                style={{
	                    minHeight: "74px",

	                    display: "flex",
	                    alignItems: "center",

	                    padding: "0 22px",

	                    borderBottom:
	                        "1px solid rgba(255,255,255,0.09)",

	                    flexShrink: 0
	                }}
	            >

	                <div
	                    style={{
	                        flex: 1,
	                        minWidth: 0
	                    }}
	                >

	                    <div
	                        style={{
	                            fontSize: "11px",

	                            color: "#94a3b8",

	                            letterSpacing: "1.4px",

	                            textTransform: "uppercase"
	                        }}
	                    >
	                        {activeTypeLabel}
	                    </div>


	                    <div
	                        style={{
	                            marginTop: "4px",

	                            color: "#ffffff",

	                            fontSize: "17px",
	                            fontWeight: 600,

	                            whiteSpace: "nowrap",
	                            overflow: "hidden",
	                            textOverflow: "ellipsis"
	                        }}
	                    >
	                        {title}
	                    </div>

	                </div>


	                <div
	                    style={{
	                        color: "#94a3b8",

	                        fontSize: "12px",

	                        marginLeft: "14px"
	                    }}
	                >
	                   {filteredItems.length}
	                </div>

	            </div>

				{/* BUTON PILL BAR */}
				
				<div style={typeBarStyle}>

				    <button
				        type="button"
				        style={{
				            ...typeButtonStyle,
				            ...leftTypeButtonStyle,
				            ...(selectedType === "INSIGHTS"
				                ? activeTypeButtonStyle
				                : {})
				        }}
				        onClick={() =>
				        {
				            setSelectedType("INSIGHTS");
				        }}
				    >
				        Insights

				        <span style={typeCountStyle}>
				            {insights.length}
				        </span>
				    </button>


				    <button
				        type="button"
				        style={{
				            ...typeButtonStyle,
				            ...middleTypeButtonStyle,
				            ...(selectedType === "OBSERVATIONS"
				                ? activeTypeButtonStyle
				                : {})
				        }}
				        onClick={() =>
				        {
				            setSelectedType("OBSERVATIONS");
				        }}
				    >
				        Observations
						<span style={typeCountStyle}>
				            {observations.length}
				        </span>
				    </button>


				    <button
				        type="button"
				        style={{
				            ...typeButtonStyle,
				            ...rightTypeButtonStyle,
				            ...(selectedType === "ASSETS"
				                ? activeTypeButtonStyle
				                : {})
				        }}
				        onClick={() =>
				        {
				            setSelectedType("ASSETS");
				        }}
				    >
				        Assets
						<span style={typeCountStyle}>
				            {potentialAssets.length}
				        </span>
				    </button>

				</div>

	            {/* SEARCH */}

	            <div
	                style={{
	                    padding: "16px 20px",

	                    flexShrink: 0
	                }}
	            >

	                <input
	                    type="text"

	                    value={search}

						placeholder={
						    selectedType === "OBSERVATIONS"
						        ?
						        "Search observations..."
						        :
						        selectedType === "ASSETS"
						            ?
						            "Search potential assets..."
						            :
						            "Search insights..."
						}

	                    onChange={(e) =>
	                        setSearch(e.target.value)
	                    }

	                    style={{
	                        width: "100%",
	                        height: "40px",

	                        boxSizing: "border-box",

	                        padding: "0 14px",

	                        borderRadius: "9px",

	                        border:
	                            "1px solid rgba(255,255,255,0.12)",

	                        outline: "none",

	                        background:
	                            "rgba(255,255,255,0.07)",

	                        color: "#ffffff",

	                        fontSize: "12px"
	                    }}
	                />

	            </div>


	            {/* LIST */}
				<div style={{marginLeft:'10px', width:'calc(100% - 20px)', paddingTop:'10px'}}>
					<ScrollableList height="calc(100vh - 200px)">
			            <div
			                style={{
			                    flex: 1,
		
			                    minHeight: 0,
		
			                    overflowY: "hidden",
		
			                    padding:
			                        "0 14px 22px 20px"
			                }}
			            >
		
						{
						    selectedType === "INSIGHTS"
						    &&
						    renderInsights()
						}

						{
						    selectedType === "OBSERVATIONS"
						    &&
						    renderObservations()
						}

						{
						    selectedType === "ASSETS"
						    &&
						    renderPotentialAssets()
						}
		
			            </div>
					</ScrollableList>
					{
					    display
					    &&
					    loading
					    &&
					    <div style={loadingOverlayStyle}>

					        <div style={loadingPanelStyle}>

					            <div style={loadingWheelStyle}>

					                <FontAwesomeIcon
					                    icon={faSpinner}
					                    spin
					                />

					            </div>

					            <div style={loadingTitleStyle}>
					                Loading location intelligence
					            </div>

					            <div style={loadingTextStyle}>
					                Refreshing insights for the current scan...
					            </div>

					        </div>

					    </div>
					}
				</div>
	        </div>

	    </>

	);
}


function Stat({
    label,
    value
})
{
    return (

        <div>
            <div
                style={{
                    color: "#64748b",

                    fontSize: "9px",

                    textTransform: "uppercase",

                    letterSpacing: "0.5px"
                }}
            >
                {label}
            </div>

            <div
                style={{
                    marginTop: "3px",

                    color: "#e2e8f0",

                    fontSize: "11px",
                    fontWeight: 600,

                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis"
                }}
            >
                {value}
            </div>
        </div>

    );
}